<template>
    <CwHeader position="sticky">
        <CContainer fluid class="headerContainer">
            <CHeaderToggler class="ps-1" @click="$store.commit('toggleSidebar')" v-if="!disableSidebar">
                <i class=" ti ti-box-align-right px-2"></i>
            </CHeaderToggler>
            <div class="ps-1" v-if="disableSidebar">
                <img src="../assets/images/workflow-transdark-512.svg" style="max-width: 150px; margin-left: 0.5em;">
            </div>
            <CHeaderBrand class="mx-auto d-lg-none" to="/">
                <img src="../assets/images/workflow-transdark-512.svg" style="max-width: 140px;">
            </CHeaderBrand>
            <CHeaderNav class="d-none d-md-flex me-auto">
                <!--<CNavItem>
                    <CNavLink href="/dashboard"> Dashboard</CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink href="#">Users</CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink href="#">Settings</CNavLink>
                </CNavItem>-->
            </CHeaderNav>
            <CHeaderNav>
                <!--<CNavItem>
                    <CNavLink href="#">
                        <CIcon class="mx-2" icon="cil-bell" size="lg"/>
                    </CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink href="#">
                        <CIcon class="mx-2" icon="cil-list" size="lg"/>
                    </CNavLink>
                </CNavItem>-->
                <NotificacionesCampana v-if="!disableSidebar" class="me-1 me-sm-3"/>
                <div class="usernameInfo me-5">
                    {{ authInfo.name }} ({{ authInfo.username }})
                </div>
                <CNavItem v-if="!disableSidebar">
                    <CNavLink @click="showStartTaskModal = true; searchProducto = ''; getPanel()" class="text-white me-0 me-sm-2">
                        <i class="ti ti-library-plus fa-lg me-2"></i><span class="d-none d-sm-inline">{{ $t('header.iniciarTarea') }}</span>
                    </CNavLink>
                </CNavItem>
                <!--<CNavItem>
                    <CNavLink href="#">
                        <i class="far fa-bell fa-lg"></i>
                    </CNavLink>
                </CNavItem>-->
                <div v-if="disableSidebar" class="btn ms-2 d-none d-sm-block text-light" style="font-size: 1em" @click="fullScreen">
                    <i :class="{'ti ti-maximize me-1': !isFullScreenEnabled, 'ti ti-maximize-off me-1': isFullScreenEnabled}"/> {{ $t('header.pantallaCompleta') }}
                </div>
                <HelpButton v-if="disableSidebar" context="flujos.editor" variant="light" class="ms-2"/>
                <div v-if="!disableSidebar" class="ms-1 ms-sm-3 me-1 mt-1" @click="$router.push('/mi-usuario')" v-tooltip="$t('header.miUsuario')">
                    <i class="ti ti-user-circle" style="font-size: 1.9em; cursor: pointer"/>
                </div>
                <div v-if="!disableSidebar" class="ms-1 ms-sm-2 me-1 me-sm-2 mt-1" @click="logout" v-tooltip="$t('header.cerrarSesion')">
                    <i class="ti ti-lock-square-rounded-filled" style="font-size: 1.9em; cursor: pointer"/>
                </div>
                <button v-if="disableSidebar" class="btn btn-light btn-sm text-primary ms-4 me-1" @click="outFromEditor" style="font-size: 0.9em; padding: 5px; height: 32px;"><i class="fas fa-door-open px-2 text-primary"></i> {{ $t('header.salirEditor') }}</button>
            </CHeaderNav>
        </CContainer>
    </CwHeader>
    <Teleport to="body">
        <div class="globalModal" v-if="showStartTaskModal">
            <div class="globalModalContainer p-3">
                <div @click="showStartTaskModal = false" class="globalModalClose mt-3"><i class="fas fa-times-circle"></i></div>
                <div>
                    <h5>{{ $t('header.modalIniciar.titulo') }}</h5>
                </div>
                <hr>
                <div class="mb-3">
                    <input type="text" class="form-control" :placeholder="$t('header.modalIniciar.buscarFlujo')" v-model="searchProducto">
                </div>
                <div class="mt-2">
                    <div class="row">
                        <div v-for="(producto, indexP) in filteredProductos" class="col-12 col-sm-4">
                            <div class="panelProductoItem">
                                <div class="panelProductoItemImg">
                                    <img v-if="producto.i !== null && producto.i !== ''" :src="producto.i || ''"/>
                                    <img v-else src="../assets/images/workflow-glifo.svg">
                                </div>
                                <div class="mt-2">
                                    {{ producto.n }}
                                </div>
                                <hr>
                                <div class="text-end">
                                    <button class="btn btn-primary btn-sm ms-2" @click="goToFlujo(producto.l)">
                                        <i class="ti ti-plus"></i> {{ $t('header.modalIniciar.iniciar') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import AppBreadcrumb from './AppBreadcrumb'
import AppHeaderDropdownAccnt from './AppHeaderDropdownAccnt'
import {logo} from '@/assets/brand/logo'
import {mapGetters, mapMutations} from "vuex";
import toolbox from "@/toolbox";
import dayjs from "dayjs";
import Button from "@/views/forms/form_elements/FormElementButton.vue";
import store from "@/store";
import CwHeader from "@/components/CwHeader.vue";
import HelpButton from "@/help/HelpButton.vue";
import NotificacionesCampana from "@/components/NotificacionesCampana.vue";
import {detener as detenerNotificaciones} from "@/utils/notificacionesCanal";
import {volverAlAdmin} from "@/utils/emulacion";

export default {
    name: 'AppHeader',
    components: {
        Button,
        AppBreadcrumb,
        AppHeaderDropdownAccnt,
        CwHeader,
        HelpButton,
        NotificacionesCampana,
    },
    setup() {
        return {
            logo,
        }
    },
    computed: {
        ...mapGetters({
            loading: 'loading',
            authInfo: 'authInfo',
            disableSidebar: 'disableSidebar',
        }),
        startTaskModalTrigger() {
            return this.$store.state.startTaskModalTrigger;
        },
        filteredProductos() {
            if (!this.searchProducto) return this.productos;
            const term = this.searchProducto.toLowerCase();
            return Object.values(this.productos).filter(p => p.n && p.n.toLowerCase().includes(term));
        },
    },
    watch: {
        startTaskModalTrigger() {
            this.showStartTaskModal = true;
            this.searchProducto = '';
            this.getPanel();
        },
    },
    data() {
        return {
            showStartTaskModal: false,
            productos: {},
            searchProducto: '',
            isFullScreenEnabled: false,
        };
    },
    methods: {
        ...mapMutations(["authSetInfo"]),
        logout() {

            const self = this;
            toolbox.doAjax('POST', 'auth/logout', {},
                function (response) {
                    detenerNotificaciones();
                    // Cerrar sesión durante una emulación solo la termina: se vuelve al super admin
                    if (self.authInfo && self.authInfo.emu) {
                        volverAlAdmin();
                        return;
                    }
                    self.authSetInfo({});
                    self.$router.push('/login');
                },
                function (response) {
                    toolbox.alert(response.msg, 'danger');
                })

            //loginClose

        },
        help() {

            const self = this;
            self.$router.push('/help');
        },
        fullScreen() {
            //$('body').toggleClass('fullscreen-enable');
            if (!document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement) { // current working methods
                if (document.documentElement.requestFullscreen) {
                    this.isFullScreenEnabled = true;
                    document.documentElement.requestFullscreen();
                }
                else if (document.documentElement.mozRequestFullScreen) {
                    this.isFullScreenEnabled = true;
                    document.documentElement.mozRequestFullScreen();
                }
                else if (document.documentElement.webkitRequestFullscreen) {
                    this.isFullScreenEnabled = true;
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            }
            else {
                if (document.cancelFullScreen) {
                    this.isFullScreenEnabled = false;
                    document.cancelFullScreen();
                }
                else if (document.mozCancelFullScreen) {
                    this.isFullScreenEnabled = false;
                    document.mozCancelFullScreen();
                }
                else if (document.webkitCancelFullScreen) {
                    this.isFullScreenEnabled = false;
                    document.webkitCancelFullScreen();
                }
            }
        },
        getPanel() {
            const self = this;
            toolbox.doAjax('POST', 'productos/get_panel', {}, function (response) {
                if (response.status) {
                    self.productos = response.data;
                }
            }, function (response) {
                self.msg = response.msg;
            })
        },
        goToFlujo(link) {
            this.showStartTaskModal = false;
            this.$router.push({ path: link }).then(() => { this.$router.go(0) })
        },
        outFromEditor() {
            store.dispatch('disableSidebar', false);
            this.$router.push('/flow-editor');
        }
    }
}
</script>
